export interface MeetingTrialVoiceBarTiming {
  delayMs: number;
  durationMs: number;
  heightPx: number;
}

export interface MeetingTrialPitchTimings {
  agentInMs: number;
  agentTransitionMs: number;
  lineFadeMs: number;
  lineStaggerMs: number;
  linesFromMs: number;
  morningFadeMs: number;
  morningInMs: number;
  noteInMs: number;
  noteTransitionMs: number;
  nudgeInMs: number;
  nudgeTransitionMs: number;
  recordingCompleteMs: number;
  recordingSettleTransitionMs: number;
  sheetEasing: string;
  sheetScrimMs: number;
  sheetSlideMs: number;
  skeletonPulseMs: number;
  status1Ms: number;
  status2Ms: number;
  status3Ms: number;
  timerFromSeconds: number;
  timerTickMs: number;
  timerToSeconds: number;
  voiceBars: readonly MeetingTrialVoiceBarTiming[];
}

/**
 * Default choreography for the meeting trial pitch.
 *
 * Every animation duration and trigger lives here so Storybook can expose one
 * editable timing object and design iteration never requires hunting through
 * component CSS or effects.
 */
export const DEFAULT_MEETING_TRIAL_PITCH_TIMINGS: MeetingTrialPitchTimings = {
  agentInMs: 8_000,
  agentTransitionMs: 600,
  lineFadeMs: 450,
  lineStaggerMs: 700,
  linesFromMs: 4_200,
  morningFadeMs: 600,
  morningInMs: 13_300,
  noteInMs: 600,
  noteTransitionMs: 600,
  nudgeInMs: 14_300,
  nudgeTransitionMs: 600,
  recordingCompleteMs: 3_500,
  recordingSettleTransitionMs: 500,
  sheetEasing: "cubic-bezier(.22, .9, .3, 1)",
  sheetScrimMs: 300,
  sheetSlideMs: 380,
  skeletonPulseMs: 1_100,
  status1Ms: 8_900,
  status2Ms: 10_400,
  status3Ms: 11_900,
  timerFromSeconds: 2_071,
  timerTickMs: 400,
  timerToSeconds: 2_078,
  voiceBars: [
    { delayMs: 50, durationMs: 550, heightPx: 6 },
    { delayMs: 0, durationMs: 720, heightPx: 12 },
    { delayMs: 200, durationMs: 630, heightPx: 9 },
    { delayMs: 100, durationMs: 800, heightPx: 13 },
    { delayMs: 300, durationMs: 600, heightPx: 7 },
  ],
};
